import { CoreData, Player } from "../types/CoreData";
import { AuthData } from "../types/AuthData";
import { Area } from "../types/AudioRegions";

export const coreDataStore = {
  ws: null as null | WebSocket,
  session_token: null as null | string,
  auth_data: null as AuthData | null,
  core_data: null as CoreData | null,
  current_areas: [] as Area[],
};

export const getClientPlayer = (uuid: string): Player | null => {
  if (coreDataStore.core_data) {
    for (const player of coreDataStore.core_data.players) {
      if (player.uuid == uuid) {
        return player;
      }
    }
  }
  return null;
};
